import { useSelector } from 'react-redux'

import {
  selectCurrentVariantCohort,
  selectCurrentVariantCohortToUse,
} from 'root-redux/selects/common'

import { Cohort } from 'root-constants'

interface ICohortInfo {
  isPrimaryHeaderCohort: boolean
  cohortToUse: Cohort
}

export const useCohortInfo = (): ICohortInfo => {
  const cohort = useSelector(selectCurrentVariantCohort)
  const parentCohort = useSelector(selectCurrentVariantCohortToUse)
  const cohortToUse = (cohort || parentCohort) as Cohort

  const isPrimaryHeaderCohort = cohortToUse === Cohort.FLOW_1_INTRO_LONG_2248

  return {
    isPrimaryHeaderCohort,
    cohortToUse,
  }
}
